module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_6.f06cbc67.png";